//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionTemplate from './SectionTemplate.vue';
export default {
  extends: SectionTemplate,
  methods: {
    onCardClick(card){
      if(card && card.url){
        window.location.assign(card.url);
      }
    }
  }
}
